import { AXIS_LOCK_ANGLES_DEG } from '../../model/constants/polygon';
import { Point } from './coordinates';

export const projectToAxisLock = (origin: Point, cursor: Point): Point => {
  const dx = cursor.x - origin.x;
  const dy = cursor.y - origin.y;
  const dist = Math.hypot(dx, dy);

  if (dist === 0) return cursor;

  const angleDeg = (Math.atan2(dy, dx) * 180) / Math.PI;

  const nearest = AXIS_LOCK_ANGLES_DEG.reduce<number>((best, a) => {
    const diffA = Math.abs(((angleDeg - a + 540) % 360) - 180);
    const diffB = Math.abs(((angleDeg - best + 540) % 360) - 180);
    return diffA < diffB ? a : best;
  }, AXIS_LOCK_ANGLES_DEG[0]);

  const rad = (nearest * Math.PI) / 180;

  return { x: origin.x + dist * Math.cos(rad), y: origin.y + dist * Math.sin(rad) };
};
